import React, { useState } from 'react'
import {
    Box,
    Button,
    Divider,
    Flex,
    FormControl,
    FormLabel,
    Input,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Select,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useToast,

} from '@chakra-ui/react'
import { useFormik } from "formik";
import axios from 'axios'
import { Auth } from './Auth';
import { BiArrowBack } from 'react-icons/bi';
// import { RxCounterClockwiseClock } from 'react-icons/rx';


// import * as Yup from "yup";

// search formik value
const searchValues = {
    partyId: '',
    phone: '',
    email: '',
    shopifyCustomerId: '',
    firstName: '',
    lastName: '',
    gst: '',
    dinNumber: ''
}

// // search Yup Validation schema
// const searchSchema = Yup.object({
//     shopifyOrderName: Yup.string(),
//     shopifyOrderId: Yup.string(),

//   });


const CustomerSearchModal = ({ onClose, create }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [searchResult, setSearchResult] = useState({status: 'Failure', error: false, isSearched: false})
    const [searchData, setSearchData] = useState([])
    // const [deliveryBoyPartyId, setDeliveryBoyPartyId] = useState([])
    const toast = useToast()
 
  

    function validateEmail(email) {
        const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return regex.test(email);
      }

    const { values,  handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: searchValues,
    //   validationSchema: searchSchema,
      onSubmit: (values, action) => {
        setIsLoading(true)
        // API CALL FOR ORDER SEARCH
        let data = JSON.stringify({
            "partyId": `${values.partyId}`,
            "email": `${values.email}`,
            "phone": `${values.phone}`,
            "shopifyCustomerId": `${values.shopifyCustomerId}`,
            "firstName": `${values.firstName}`,
            "lastName": `${values.lastName}`,
            "gst": `${values.gst}`,
            "dinNumber": `${values.dinNumber}`
          });
          
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/party/context/search`,
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': Auth()
            },
            data : data
          };
          
          axios.request(config)
          .then((response) => {
            if(response.data.length > 0){
                setIsLoading(false)
                setSearchData(response.data);
                setSearchResult({status: 'Success', error: false, isSearched: true})
            }else{
                setSearchResult({status: 'Success', error: false, isSearched: false})
                toast({
                    title: 'Your search did not match with any order detials',
                    status: 'error',
                    duration: 4000,
                    position: 'bottom',
                    isClosable: true,
                })
                setIsLoading(false)
            }
            
          })
          .catch((error) => {
            setIsLoading(false)
            console.log(error);
            setSearchResult({status: 'Failure', error: true, isSearched: false})
            toast({
                title: 'Oops we are facing some temporary issue with your request',
                status: 'error',
                duration: 3000,
                position: 'bottom',
                isClosable: true,
              })
          });
        
        action.resetForm()
      },
    });


    
      
   
  return (
    <ModalContent>
    <ModalHeader textAlign={'center'}>
    <Flex w={'full'}>
        <Box flexBasis={'3%'}>
        {searchResult.isSearched &&
            <BiArrowBack onClick={() => {
                setSearchResult({status: 'Failure', error: false, isSearched: false})
                setSearchData([])
                // setDeliveryBoyPartyId([])
            }} fontSize={'32px'} style={{cursor: "pointer"}}/>
        }
        </Box>
        <Box flexBasis={'97%'}>
            Search Customer
        </Box>

    </Flex>
    </ModalHeader>
    <Divider/>
    <ModalCloseButton mt={'7.5px'} />
    <ModalBody pb={6}>
    {searchResult.isSearched ?
                 // ##### SEARCHED RESULT #####
                <TableContainer height={`${window.innerHeight - 244}px`} overflowY={'scroll'}>
                    <Table variant={'simple'} size={'xs'}>
                        <Thead bgColor={'gray.100'} position={'sticky'} top={'0px'} zIndex={'99'}>
                            <Tr bgColor={'#E2DFDF'}>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Shopify Customer Id"}</Th>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Customer Name"}</Th>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Email"}</Th>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Phone"}</Th>
                              
                            </Tr>
                        </Thead>
                        <Tbody >
                            {searchData.map((d, i) => (
                                
                                <Tr key={i}  bgColor={'white'}>
                                  
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} pl={4} >{d.shopifyCustomerId}</Td>    
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} >{d.firstName + " " + d.lastName}</Td>    
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} >{d.email}</Td>    
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} >{d.phone}</Td>    
                                   
                                </Tr>
                            ))}
                        </Tbody>        
                    </Table>
                </TableContainer>
    :
    <>
    {/* ##### SEARCH FIELDS #### */}
     <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Party Id</FormLabel>
                <Input placeholder='Enter Party Id' name='partyId' value={values.partyId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>

            <FormControl mt={4} flexBasis={'47%'} >
                <FormLabel>Shopify Customer Id</FormLabel>
                <Input placeholder='Enter Shopify Customer Id' name='shopifyCustomerId' value={values.shopifyCustomerId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
    </Flex>

        <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Din Number</FormLabel>
                <Input placeholder='Enter Din Number' name='dinNumber' value={values.dinNumber} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>

            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>GST</FormLabel>
                <Input placeholder='Enter GST' name='gst' value={values.gst} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
             </FormControl>
        </Flex>

        <Flex justifyContent={'space-between'}>
             <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>First Name</FormLabel>
                <Input placeholder='Enter First Name' name='firstName' value={values.firstName} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
             </FormControl>

            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Last Name</FormLabel>
                <Input placeholder='Enter Last Name' name='lastName' value={values.lastName} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
        
        </Flex>
        <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'} >
                <FormLabel>Phone</FormLabel>
                <Input placeholder='Enter Customer Phone Number' name='phone' value={values.phone} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
            <FormControl mt={4} flexBasis={'47%'} >
                <FormLabel>Email</FormLabel>
                <Input placeholder='Enter Email Id' name='email' value={values.email} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
        </Flex>

        </>
     }



        
    </ModalBody>

    <ModalFooter w={'full'}>
         {/* <Button  mr={3} onClick={onClose} width={'50%'}>Cancel</Button> */}
         <Button colorScheme='green' onClick={handleSubmit} width={'100%'} isLoading={isLoading}
         isDisabled={!(
            values.partyId.length > 0 || values.phone.length >= 10 || validateEmail(values.email)  || values.shopifyCustomerId.length > 0
            || values.firstName.length >= 2 || values.lastName.length >= 2 || values.gst.length > 0 || values.dinNumber.length > 0    )
         }
         >
             Search
         </Button>
    </ModalFooter>
</ModalContent>
  )
}

export default CustomerSearchModal